import { useTranslation } from 'react-i18next'
import { TVariable } from 'src/types/variable'
import { TNavigationLocales } from 'src/types/locales'
import { useState, useEffect } from 'react'
import { CrossIcon, CurecallTextButton, RoundInfoIcon } from '@honestica/curecall-ui'

interface VariableSuggestionProps {
  suggestions: TVariable[]
  language: TNavigationLocales
  onSuggestionClick: (variableId: number) => void
}

export function VariableSuggestion({
  suggestions,
  language,
  onSuggestionClick,
}: Readonly<VariableSuggestionProps>) {
  const { t } = useTranslation()
  const [isClosed, setIsClosed] = useState(false)

  useEffect(() => {
    if (suggestions.length > 0) {
      setIsClosed(false)
    }
  }, [suggestions])

  if (suggestions.length === 0 || isClosed) {
    return null
  }

  return (
    <div className="c-mt-2 c-w-full c-border c-border-grey-500 c-rounded-lg c-bg-blue-50 c-overflow-hidden c-shadow-sm">
      <div className="c-flex c-items-center c-justify-between c-px-4 c-py-3 c-bg-grey-100">
        <div className="c-flex c-items-center c-gap-2">
          <RoundInfoIcon className="c-h-5 c-w-5 c-text-primary-400" />
          <span className="c-text-sm c-text-gray-700 c-font-medium">
            {t('pages.configuration.followups.chatbot.variable-modal.similar-variables-title')}
          </span>
        </div>
        <button
          type="button"
          onClick={() => setIsClosed(true)}
          className="c-text-gray-700 hover:c-text-gray-900 c-transition-colors c-flex-shrink-0"
          aria-label={t('common.actions.close')}
        >
          <CrossIcon className="c-h-5 c-w-5" />
        </button>
      </div>
      <div className="c-bg-white c-divide-y c-divide-gray-200">
        {suggestions.map((variable) => (
          <div
            key={variable.id}
            className="c-flex c-items-center c-justify-between c-px-4 c-py-1 hover:c-bg-gray-50 c-transition-colors"
          >
            <span className="c-text-sm c-text-gray-700">{variable.intlLabel?.[language]}</span>
            <CurecallTextButton
              type="button"
              className="c-whitespace-nowrap c-text-sm"
              onClick={() => onSuggestionClick(variable.id)}
            >
              {t('pages.configuration.followups.chatbot.variable-modal.select-variable')}
            </CurecallTextButton>
          </div>
        ))}
      </div>
    </div>
  )
}
